export const SessionReplayPlayer = ({ playUrl, title, onClose, headerAction = null }) => {
    if (!playUrl) {
        return (
            <div className="flex items-center justify-center h-full bg-gray-900 rounded-lg text-gray-400 text-sm">
                Grabación no disponible
            </div>
        );
    }

    return (
        <div className="flex flex-col h-full bg-gray-900 overflow-hidden">
            <div className="flex items-center gap-3 px-4 py-2 bg-gray-800 text-white">
                <p className="flex-1 min-w-0 text-sm font-medium truncate">
                    {title || 'Clase grabada'}
                </p>
                {headerAction}
                {onClose ? (
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex-shrink-0 px-3 py-1 rounded-md text-xs font-semibold bg-gray-700 hover:bg-gray-600 transition-colors"
                    >
                        Cerrar
                    </button>
                ) : null}
            </div>
            <div className="flex-1 min-h-0">
                <video
                    src={playUrl}
                    controls
                    className="w-full h-full object-contain bg-black"
                >
                    <track kind="captions" />
                </video>
            </div>
        </div>
    );
};
